<template>
  <div class="suppliers-list">
    <div class="row justify-content-center">
      <div
        class="col-sm col-md-6 col-lg-4 row-col"
        v-for="(value, index) in suppliers"
        :key="index"
      >
        <div class="row justify-content-center">
          <div class="card">
            <img :src="value.image" class="card-img-top" :alt="value.image" />
            <div class="card-body">
              <div class="row justify-content-between">
                <div class="col-12 col-sm-6">
                  <h5 class="card-title">
                    <router-link
                      class="product-link text-uppercase"
                      :to="`/suppliers/${value.uuid}`"
                      >{{ value.name }}</router-link
                    >
                  </h5>
                </div>
                <div class="col-12 col-sm-6 text-left text-md-right">
                  <a :href="'https://' + value.socmed" target="_blank"
                    ><i
                      v-b-tooltip.hover
                      :title="translate('tooltips.website')"
                      class="fa fa-globe fa-1x mr-4 mr-md-0 ml-md-4"
                      :style="{ color: '#FF9A21' }"
                    ></i
                  ></a>
                  <a :href="'https://' + value.twitter_url" target="_blank"
                    ><i
                      v-b-tooltip.hover
                      :title="translate('tooltips.twitter')"
                      class="fab fa-twitter fa-1x mr-4 mr-md-0 ml-md-4"
                      :style="{ color: '#FF9A21' }"
                    ></i
                  ></a>
                  <a :href="'https://' + value.facebook_url" target="_blank"
                    ><i
                      v-b-tooltip.hover
                      :title="translate('tooltips.facebook')"
                      class="fab fa-facebook fa-1x mr-4 mr-md-0 ml-md-4"
                      :style="{ color: '#FF9A21' }"
                    ></i
                  ></a>
                </div>
              </div>
              <div class="row justify-content-between">
                <div class="col-3 col-sm-4">
                  <b-icon icon="people-fill" aria-hidden="true"></b-icon>
                  {{ value.our_team }}
                </div>
                <div class="col-4 col-sm-4">
                  <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                  {{ value.num_proj }}
                </div>
                <div class="col-4 col-sm-4">
                  <b-icon icon="collection-fill" aria-hidden="true"></b-icon>
                  {{ value.numexp }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['suppliers']
}
</script>

<style lang="scss" scoped>
.card-img-top {
  width: 100%;
  height: 250px;
  object-fit: cover;
  object-position: 50% -20%;
}
.card {
  width: 90%;
  -webkit-box-shadow: -4px 16px 12px -15px rgba(255, 154, 33, 1);
  -moz-box-shadow: -4px 16px 12px -15px rgba(255, 154, 33, 1);
  box-shadow: -4px 16px 12px -15px rgba(255, 154, 33, 1);
}
.row-col {
  margin-bottom: 20px;
}
.product-link:hover {
  text-decoration: none;
}
</style>